import * as $ from 'jquery';
import { CompanyPayingApplication } from './CompanyPayingApplication';

$(() => {
    const companyPayingPage = $('[data-company-paying-page]');
    // If we are not on companyPaying page we stop script
    if (companyPayingPage.length === 0) {
        return;
    }

    let container = $(companyPayingPage[0]);
    container.data('companyPayingApp', new CompanyPayingApplication(container));
});
